import styled from '@emotion/styled';
import {
  bodyM,
  subTitle2,
  tag1M,
  tag1Sb,
  title2,
} from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(20, 20, 20, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  -moz-backdrop-filter: blur(8px);
  -o-backdrop-filter: blur(8px);
  -ms-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  overflow: auto;

  @supports not (backdrop-filter: blur(8px)) {
    background-color: rgba(20, 20, 20, 0.8);
  }
`;

export const ModalContainer = styled.div`
  width: 375px;
  height: 634px;
  z-index: 2;
  padding: 3rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: -30px;
  right: -25px;
  z-index: 3;
  padding: 16px;
`;

export const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  height: 100dvh;
`;

export const Title = styled.div`
  ${title2};
  color: ${vars.neutral[0]};
  text-align: center;
  white-space: pre-line;
`;

export const Description = styled.div`
  ${bodyM};
  color: ${vars.neutral[0]};
  text-align: center;
  display: -webkit-box;
  max-height: 56px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  font-size: 13px;
`;

export const ModalDonationCertificateWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 20px 42px;
  width: 280px;
  border-radius: 12px;
  height: 390px;
  background-image: url('/images/campaign/campaign_certificate_bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 12px;
`;

export const CertificateName = styled.div`
  color: #000000;
  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
export const CertificateImageWrapper = styled.div`
  position: relative;
  object-fit: cover;
  width: 200px;
  height: 160px;
`;
export const CertificateTitle = styled.div`
  width: 100%;
  max-height: 56px;
  text-align: center;
  ${subTitle2};
  color: #141617;
`;

export const CertificateDescription = styled.div`
  display: flex;
  width: 233px;
  height: 22px;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  ${tag1M};
  color: ${vars.neutral[70]};
`;

export const CertificateBody = styled.div`
  display: flex;
  width: 180px;
  height: 24px;
  padding: 4px 10px;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  background: #fff;

  ${tag1Sb};
  color: #3a3e41;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  gap: 12px;
  width: 100%;
  margin-top: auto;
  padding: 0px 0px 2rem 0px;
`;
